import { TransformNullValue } from 'metrics-chart'

export interface ChartConfig {
  key: string
  title: string
  unit: string
  tag?: string // 可选的 Tag，用于指定使用哪个 Tag 的数据
  nullValue?: TransformNullValue
}

export const CHART_CONFIGS: ChartConfig[] = [
  {
    key: 'cps',
    title: 'CPS',
    unit: 'short'
  },
  {
    key: 'cpu_tidb',
    title: 'TiDB CPU',
    unit: 'percentunit'
  },
  {
    key: 'cpu_tikv',
    title: 'TiKV CPU',
    unit: 'percentunit'
  },
  {
    key: 'cpu_tiflash',
    title: 'TiFlash CPU',
    unit: 'percentunit'
  },
  {
    key: 'iops_exceed_max',
    title: 'IOPS Exceed Max',
    unit: 'short',
    nullValue: TransformNullValue.NULL
  },
  {
    key: 'iops_exceed_avg',
    title: 'IOPS Exceed Avg',
    unit: 'short',
    nullValue: TransformNullValue.NULL
  },
  {
    key: 'latency_p999_all',
    title: 'P999',
    unit: 'ms'
  },
  {
    key: 'latency_p99_all',
    title: 'P99',
    unit: 'ms'
  },
  {
    key: 'latency_p95_all',
    title: 'P95',
    unit: 'ms'
  },
  {
    key: 'latency_avg_all',
    title: 'Duration Avg',
    unit: 'ms'
  }
]

export const TRAFFIC_VALIDATION_CHART_CONFIGS: ChartConfig[] = [
  {
    key: 'qps_by_type',
    title: 'QPS by Type Select',
    unit: 'short',
    tag: 'Select'
  },
  {
    key: 'qps_by_type',
    title: 'QPS by Type Insert',
    unit: 'short',
    tag: 'Insert'
  },
  {
    key: 'qps_by_type',
    title: 'QPS by Type Update',
    unit: 'short',
    tag: 'Update'
  },
  {
    key: 'qps_by_type',
    title: 'QPS by Type Delete',
    unit: 'short',
    tag: 'Delete'
  },
  {
    key: 'affected_rows_by_type',
    title: 'Affected Rows by Replace',
    unit: 'short',
    tag: 'Replace'
  },
  {
    key: 'affected_rows_by_type',
    title: 'Affected Rows by Insert',
    unit: 'short',
    tag: 'Insert'
  },
  {
    key: 'affected_rows_by_type',
    title: 'Affected Rows by Update',
    unit: 'short',
    tag: 'Update'
  },
  {
    key: 'affected_rows_by_type',
    title: 'Affected Rows by Delete',
    unit: 'short',
    tag: 'Delete'
  }
]

export const PERFORMANCE_CHART_CONFIGS: ChartConfig[] = [
  {
    key: 'latency_p999',
    title: 'Latency P999 by Type Select',
    unit: 'ms',
    tag: 'Select'
  },
  {
    key: 'latency_p999',
    title: 'Latency P999 by Type Insert',
    unit: 'ms',
    tag: 'Insert'
  },
  {
    key: 'latency_p999',
    title: 'Latency P999 by Type Update',
    unit: 'ms',
    tag: 'Update'
  },
  {
    key: 'latency_p999',
    title: 'Latency P999 by Type Delete',
    unit: 'ms',
    tag: 'Delete'
  },
  {
    key: 'latency_avg_by_type',
    title: 'Latency Avg by Type Select',
    unit: 'ms',
    tag: 'Select'
  },
  {
    key: 'latency_avg_by_type',
    title: 'Latency Avg by Type Insert',
    unit: 'ms',
    tag: 'Insert'
  },
  {
    key: 'latency_avg_by_type',
    title: 'Latency Avg by Type Update',
    unit: 'ms',
    tag: 'Update'
  },
  {
    key: 'latency_avg_by_type',
    title: 'Latency Avg by Type Delete',
    unit: 'ms',
    tag: 'Delete'
  },
  {
    key: 'tikv_performance',
    title: 'TiKV Performance',
    unit: 'ms'
  },
  {
    key: 'tiflash_performance',
    title: 'TiFlash Performance',
    unit: 'ms'
  }
]
